import axios from 'axios';
import { API } from '../../constants';

const createAction = name => ({
    KEYWORD_CHANGE: `${name}_KEYWORD_CHANGE`,
    SEARCH_ITEM_PENDING: `${name}_SEARCH_ITEM_PENDING`,
    SEARCH_ITEM_SUCCESS: `${name}_SEARCH_ITEM_SUCCESS`,
    SEARCH_ITEM_FAILED: `${name}_SEARCH_ITEM_FAILED`
});

export const SEARCH = createAction('SEARCH');

export const KeywordChange = value => dispatch => {
    dispatch({
        type: SEARCH.KEYWORD_CHANGE,
        payload: value
    });
};

export const SearchItemFormKeyword = keyword => async (dispatch, getState) => {
    dispatch({ type: SEARCH.SEARCH_ITEM_PENDING });

    try {
        const { currentLanguage } = getState().language;
        const response = await axios
            .get(`${API.SEARCH}${keyword}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': currentLanguage
                }
            })
            .then(res => res.data)
            .catch(error => Promise.reject(error));

        dispatch({
            type: SEARCH.SEARCH_ITEM_SUCCESS,
            payload: response
        });
    } catch (error) {
        dispatch({
            type: SEARCH.SEARCH_ITEM_FAILED,
            error
        });
    }
};
